export default "__VITE_ASSET__BOgRGxI0__"